module.exports = __webpack_public_path__ + "static/media/background-grid-white.553802dc.svg";